const APP_ENV = process.env.NEXT_PUBLIC_APP_ENV
  ? process.env.NEXT_PUBLIC_APP_ENV
  : process.env.APP_ENV
  ? process.env.APP_ENV
  : 'development'

export const isDevEnv = (): boolean => !APP_ENV || APP_ENV === 'development'
export const isStagingEnv = (): boolean => APP_ENV === 'staging'
export const isProductionEnv = (): boolean => APP_ENV === 'production'
